<ngx-loading
  [show]="loading$ | async"
  [config]="{ backdropBorderRadius: '3px' }"
></ngx-loading>
